import { DaySwitcher } from "../DaySwitcher/DaySwitcher";
import styles from "./PageToolbar.module.scss";

type IPageToolbar = {
  children?: React.ReactNode;
  /**
   * Renders a `DaySwitcher` as the first element in the toolbar. Use this
   * when the day switcher should sit on its own at the start of the
   * toolbar. If it needs to be placed somewhere else — e.g. next to a
   * back button and a heading — set this to `false` and render
   * `<DaySwitcher />` as a child instead.
   */
  showDaySwitcher: boolean;
};

const PageToolbar = ({ children, showDaySwitcher }: IPageToolbar) => {
  return (
    <section className={styles.toolbar}>
      {showDaySwitcher ? <DaySwitcher size="h2" /> : null}
      {children}
    </section>
  );
};

export { PageToolbar };
